import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';
import Select from "react-select";
import { baseURL_Radio_Compaign } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';

export class reserveJackpot extends React.Component {

    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            showError: false,
            email_address: '',
            userDetail: false,
            isShowError: false,
            terms_channel: [
                {
                    label: 'live',
                    value: 'live',
                },
                {
                    label: 'normal',
                    value: "normal"
                }
            ]
        }



        localStorage.setItem("phone_2", null);
    }


    handleChangeChannel = value => {
        if (value != null) {
            this.setState(
                {
                    jackpot: value.value,
                });
        }
        else {
            this.setState(
                {
                    jackpot: "",
                });

        }
    }

    componentDidMount() {
        axios.get(baseURL + 'basket').then((response) => {

            console.log('bayoo', response.data)

            // alert(baseURL_Radio_Compaign + 'validators')

            // alert(JSON.stringify(response.data[0].balance))


            this.setState({
                current_mini_jackpot: response.data[4].balance,
                current_live_jackpot: response.data[1].balance,
                // current_sure_jackpot: response.data[2].sure,
                // current_jackpot: response.data[3].jackpot

            });
        }).catch(error => {
        })
    }

    onSubmit(e) {
        e.preventDefault();

        let formData = {

            "amount": this.state.amount,
            "jackpot": this.state.jackpot

        }
        this.setState({ isLoading: true });
        var sha512 = require('js-sha512');
        let signature = sha512(this.state.amount + 'P@s5w0rd_5@lt' + this.state.jackpot);
        axios.post(baseURL_Radio_Compaign + 'reserve_jackpot', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "signature": signature
            },
        }).then((response) => {
            if (response.data.code = "0000") {

                alert("success")
                this.setState({
                    statusMessage: response.data.message,
                    isShowError: true, isLoading: false, showError: false,

                });
                setTimeout(() => {
                    this.setState({
                        statusMessage: response.data.message,
                        phone_number: '',
                        email_address: '',
                        userDetail: true,
                        isShowError: true, isLoading: false, showError: false,
                    });
                }, 1000);
            } else {
                this.setState({
                    statusMessage: response.data.message, email_address: '',
                    phone_number: '', userDetail: false, showError: true, isShowError: false, isLoading: false
                });
            }
        }).catch(error => {
            console.log('bayoo', error.response)
            this.setState({
                showError: true,
                isShowError: false,
                phone_number: '',
                email_address: '',
                userDetail: false,
                statusMessage: error.response.data.message,
                submitted: true,
                isLoading: false
            });
        });


    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    formatCurrency = amount => {
        return new Intl.NumberFormat(this.state.locale, {
            style: 'currency',
            currency: "ABS",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount).replaceAll('ABS', '');
    };
    render() {
        const { showComponent } = this.state;
        const { hideComponent, userDetail } = this.state;

        return (
            <div className="pcoded-main-container">
                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>

                                <CardBody>
                                    <div className="card__title">
                                        <h5 className="bold-text">Clear JackPot</h5>
                                    </div>
                                    {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}
                                    </div> : null}<br></br>
                                    <h4><b>Jackpot Balances <i class="fa fa--scale" aria-hidden="true"></i></b></h4><br />

                                    <h5>Normal Jackpot:
                                        <b>
                                            {
                                                this.state.current_mini_jackpot != null ?
                                                    this.formatCurrency(this.state.current_mini_jackpot) :
                                                    this.state.current_mini_jackpot
                                            }
                                        </b>
                                    </h5>
                                    <br />

                                    <h5>Live JackPot:
                                        <b>
                                            {
                                                this.state.current_live_jackpot != null ?
                                                    this.formatCurrency(this.state.current_live_jackpot) :
                                                    this.state.current_live_jackpot
                                            }
                                        </b>
                                    </h5>
                                    {this.state.isShowError ? (
                                        <div color="success" style={{ fontSize: "13px", color: "green" }}>

                                            {this.state.statusMessage}

                                        </div>
                                    ) : null}<br></br>

                                    <form className="col-md-8 offset-md-2" onSubmit={this.onSubmit}>

                                        <span className="form__form-group-label">Jackpot (live etc)</span>


                                        <Select
                                            isClearable
                                            options={this.state.terms_channel}
                                            // onInputChange={this.loadOptions}
                                            placeholder="Select JackPot type"
                                            autosize={true}
                                            onChange={this.handleChangeChannel}
                                            // isLoading={this.state.isLoading}
                                            // noOptionsMessage={() => 'nothing found'}
                                            // loadingMessage={() => 'searching...'}   //minor type-O here
                                            className="selected"
                                            menuPortalTarget={document.body}
                                            name="namffe"
                                        /><br />

                                        <br />
                                        <span className="form__form-group-label">Amount</span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-icon">
                                                <Card />
                                            </div>

                                            <input id="input" type="number" className="form-control input-md"
                                                name="amount" placeholder="Enter Amount"
                                                value={this.state.amount} onChange={this.handleChange} />

                                        </div>
                                        <br />
                                        <div className="col-12">
                                            <br /><br />
                                            <Button type="submit" outline color="primary" className="float-right" >
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}
                                            </Button> &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </form>

                                </CardBody>
                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
